import { HtmlWidget } from './htmlWidget';

export interface HpMessageWidgetProps {
  message: string | undefined;
  type: 'error' | 'success';
}

/**
 * The common version of this widget is the ErrorWidget.
 * Only use this version if you want to display a success message.
 */
export function MessageWidget({ message, type }: HpMessageWidgetProps): JSX.Element | null {
  if (message) {
    const className = `av-${type}-message`;
    const body =
      type === 'error' ? (
        <div className={className}>{message}</div>
      ) : (
        <HtmlWidget className={className} html={message} />
      );

    return <div className="av-field-messages">{body}</div>;
  }

  return null;
}
